export enum AreaType {
  AreaTypeUndefined = "UNDEFINED",
  AreaTypeInside = "INSIDE",
  AreaTypeOutside = "OUTSIDE",
}

export enum LevelType {
  LevelTypeUndefined = "UNDEFINED",
  LevelTypeInside = "INSIDE",
  LevelTypeOutside = "OUTSIDE",
}
